import script from "./pwaStatusPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwaStatusPopup.vue?vue&type=script&setup=true&lang=ts"

import "./pwaStatusPopup.vue?vue&type=style&index=0&id=88a62a8c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88a62a8c"]])

export default __exports__